import type { MouseEvent, ReactNode } from "react";
import { styled } from "styled-components";

import { ImageBackground, SourceLabel } from "common/components";
import { ListImage } from "common/components/lists/ListLink";
import { StyledContent, StyledTitle, StyledType } from "domains/knowledgeFeed/components/shared";
import { KnowledgeDetailButton } from "domains/publication/components/KnowledgeDetailButton";
import type { KnowledgeType, Source } from "entities/knowledge/types";

const StyledImage = styled(ListImage)`
  width: 100px;
  height: 60px;
  border-radius: 4px;
  margin-right: 15px;
`;

export const StyledWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

type BrowseInnerContentProps = { title: string; imageUrl?: string; source: Source; timestamp?: number };

export const BrowseInnerContent = ({ title, imageUrl, source, timestamp }: BrowseInnerContentProps) => (
  <>
    <StyledImage src={imageUrl} />
    <StyledContent>
      <StyledTitle>{title}</StyledTitle>
      {source && <SourceLabel source={source} date={timestamp} type="small" />}
    </StyledContent>
  </>
);

const StyledLatestViewImage = styled(ImageBackground)`
  width: 4rem;
  min-width: 4rem;
  height: 4rem;
  border-radius: 5px;
  margin-right: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const StyledLatestViewContent = styled.div`
  justify-content: center;
  display: flex;
  flex-direction: column;
`;

const StyledContentWrapper = styled.div`
  display: flex;
`;

type LatestViewInnerContentProps = {
  articleAnnouncement?: ReactNode;
  title: string;
  imageUrl?: string;
  knowledgeType: KnowledgeType;
  source: Source;
  timestamp?: number;
  link?: string;
};

export const LatestViewInnerContent = ({
  title,
  imageUrl,
  knowledgeType,
  source,
  timestamp,
  link,
  articleAnnouncement,
}: LatestViewInnerContentProps) => {
  const onDetailLinkClick = (event: MouseEvent) => {
    event.stopPropagation();
  };

  return (
    <>
      {articleAnnouncement}
      <StyledWrapper>
        <StyledContentWrapper>
          <StyledLatestViewImage src={imageUrl} />
          <StyledLatestViewContent>
            <StyledType>{knowledgeType}</StyledType>
            <StyledTitle>{title}</StyledTitle>
            {source && <SourceLabel source={source} date={timestamp} type="small" />}
          </StyledLatestViewContent>
        </StyledContentWrapper>
        {link && <KnowledgeDetailButton link={link} onClick={onDetailLinkClick} title={title} />}
      </StyledWrapper>
    </>
  );
};
